export default __webpack_public_path__ + "static/media/arrows-white.b6ca783c.svg";